<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m23.7 22.3-5.96-5.98a10.02 10.02 0 1 0-1.42 1.42l5.97 5.97a1 1 0 0 0 1.42-1.42M10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m3-9H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" class="tw-fill-namaGray dark:tw-fill-white"/></svg>
</template>
